export default "__VITE_ASSET__D45lZQLB__"